import { Hero, Intro, Featured } from "../components/home/Top";
import { Standard, Signature, Financing } from "../components/home/Middle";
import { GoodCompany, WorldAccording, ConsultSection } from "../components/home/Bottom";
import { BeforeAfter } from "../components/BeforeAfter";
import { Lookbook } from "../components/Lookbook";
import { JournalTeaser } from "../components/home/JournalTeaser";
import { Reviews } from "../components/Reviews";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Intro />
      <Lookbook />
      <Featured />
      <Standard />
      <Signature />
      <BeforeAfter />
      <Reviews />
      <Financing />
      <GoodCompany />
      <WorldAccording />
      <JournalTeaser />
      <ConsultSection />
    </main>
  );
}
